const crystallodeTrack = (eventName, parameters = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...parameters });
  if (typeof window.gtag === 'function') window.gtag('event', eventName, parameters);
};

document.addEventListener('click', (event) => {
  const target = event.target.closest('[data-crystallode-event]');
  if (!target) return;
  crystallodeTrack(target.dataset.crystallodeEvent, {
    page_type: target.dataset.pageType || '',
    product_sku: target.dataset.productSku || '',
    market: target.dataset.market || '',
    language: target.dataset.language || ''
  });
});

document.querySelectorAll('[data-crystallode-success-event]').forEach((element) => {
  crystallodeTrack(element.dataset.crystallodeSuccessEvent);
});

// 第 8 项：页脚「由 Shopify 提供技术支持」→「由 Crystallode 提供」。
//
// 为什么在这里改而不改 sections/footer.liquid：
// footer.liquid 是 Trade 基线文件（约 20KB），为一行文案改它，以后 Trade 升级时
// 这个文件就会冲突。文案替换放在这里，基线文件保持原样。
// 如果以后想改成模板级修改：把 sections/footer.liquid 里的
//   <small class="copyright__content">{{ powered_by_link }}</small>
// 换成写死的文案，并删掉下面这段。
//
// 页脚在页面最底部，用户滚到那里之前这段早已执行完，不会看到文案闪变。
(() => {
  const swapPoweredBy = () => {
    const link = document.querySelector('.copyright__content a[href*="shopify.com"]');
    if (!link) return;
    const holder = link.closest('.copyright__content') || link.parentElement;
    if (!holder) return;
    const isZh = (document.documentElement.lang || '').toLowerCase().indexOf('zh') === 0;
    holder.textContent = isZh ? '由 Crystallode 提供' : 'Powered by Crystallode';
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', swapPoweredBy);
  } else {
    swapPoweredBy();
  }
})();
